/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
import { nanoid } from "nanoid";

type SupportedModes = "javascript" | "json";

export interface IEditorInstance {
    getText(): string | undefined;
    setText(text: string): void;
}
interface IProps {
    mode: SupportedModes;
    width?: string;
    height?: string;
    initialValue?: string;
    placeholder?: string;
    onChange?: (value: string) => any;
    onInstance?: (instance: IEditorInstance) => any;
}

export function AdvancedTextEditor(props: IProps) {
    const { onChange, initialValue, mode, placeholder, width, height, onInstance } = props;
    const [key] = useState(nanoid());
    const [value, setValue] = useState(initialValue);
    const [valueWrapper] = useState<{ value?: string }>({});
    valueWrapper.value = value;

    useEffect(() => {
        if (onInstance) {
            onInstance({ getText: () => valueWrapper.value, setText: (text) => setValue(text) })
        }
    }, [onInstance]);

    return (<AceEditor
        key={key}
        placeholder={placeholder}
        mode={mode}
        theme="monokai"
        name={key}
        width={width}
        height={height}
        //onLoad={this.onLoad}
        onChange={(x) => { setValue(x); if (onChange) onChange(x); }}
        fontSize={14}
        showPrintMargin={true}
        showGutter={true}
        highlightActiveLine={true}
        value={value}
        setOptions={{
            // enableBasicAutocompletion: false,
            // enableLiveAutocompletion: false,
            // enableSnippets: false,
            showLineNumbers: true,
            tabSize: 4,
        }} />)
}
